// extracted by mini-css-extract-plugin
export default {"menu":"SecondaryMenu_menu__WGFoh","mobile":"SecondaryMenu_mobile__2P+zR","deleteBtn":"SecondaryMenu_deleteBtn__mAH85"};